<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Fees Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a :href="path" style="color: yellow;" target="blank">
                    Payment Policy!!!
                </a>
            </v-toolbar>
            <v-row justify="center">
                <v-tooltip top color="warning">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="red" outlined rounded small class="button" v-bind="attrs" v-on="on"
                            @click="dialog_issue = true"> Amount deducted but receipt not generated. click here</v-btn>
                    </template>
                    <span>
                        Steps to raise dispute.
                    </span>
                </v-tooltip>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0f2027" rounded v-model="selected_children" :items="children"
                        label="Select Child" item-text="name" item-value="id" outlined dense
                        prepend-icon="mdi-account-child-circle" @click="show = false"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" @click="getData()">Proceed</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="basic_student_data != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title> Student Details </v-toolbar-title>
            </v-toolbar>
            <span v-if="basic_student_data != null">
                <v-row justify="center" dense>
                    <v-col cols="12" sm="6" md="6"><strong>Name : </strong>{{ basic_student_data.registration_number }}
                        : {{ basic_student_data.student_name }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Admission Year : </strong>{{
                        basic_student_data.learner_addmission_year }}</v-col>
                    <v-col cols="12" sm="3" md="3" class="flash"><strong>Current Wallet Balance : {{
                            current_wallet_balance }}</strong></v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Standard : </strong>{{ basic_student_data.standard }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Division : </strong>{{ basic_student_data.division }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Roll No. : </strong>{{ basic_student_data.roll_no }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Quota : </strong>{{ basic_student_data.quota }}</v-col>
                </v-row>
                <v-row v-if="payment_data != null" justify="center" dense>
                    <v-col cols="12" sm="12" md="12">
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title> Add Money To Wallet </v-toolbar-title>
                        </v-toolbar>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Amount To Pay" v-model="amount" placeholder="123" type="number" dense
                            rounded outlined hint="Please Enter Amount It's Rsequired"></v-text-field>
                    </v-col>
                    <form :action="url" @submit="payment" name="paytmform" method="POST">
                        <input type="hidden" :value="payment_data[0].orgid" name="orgid" />
                        <input type="hidden" :value="payment_data[0].tenantid" name="tenantid" />
                        <input type="hidden" :value="payment_data[0].uid" name="uid" />
                        <input type="hidden" :value="payment_data[0].learner_id" name="studid" />
                        <input type="hidden" :value="payment_data[0].wallet_id" name="json_pre_trans_data" />
                        <input type="hidden" :value="amount" name="fee_amount" />
                        <v-btn class="button" type="submit" :loading="loader" :disabled="amount == 0 "
                            v-if="amount">Pay</v-btn>
                    </form>
                    <!-- <v-btn v-if="amount" :loading="loader" class="button">Pay</v-btn> -->
                </v-row>
            </span>


        </v-card>
        <v-card class="box" v-if="basic_student_data != null">
            <v-expansion-panels class="expapanel no-display" focusable inset>
                <v-expansion-panel>
                    <v-expansion-panel-header class="panelheader toolbar12">Recharge History </v-expansion-panel-header>
                    <v-expansion-panel-content class="mt-5">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-data-table v-if="richarge_history != ''" dense class="elevation-1 mytable"
                                    :headers="headers" :items="bookList1" fixed-header @current-items="getFiltered">
                                    <template v-slot:top class="pb-5">
                                        <v-row justify="center" align="center">
                                            <tr class="t-row">
                                                <div>
                                                    <th>
                                                        <v-row>
                                                            <span v-for="header in headers" :key="header.text">
                                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat
                                                                        hide-details small rounded dense outlined
                                                                        color="#0F2027" :label="header.text" multiple
                                                                        clearable :items="columnValueList(header.value)"
                                                                        v-model="filters[header.value]"></v-autocomplete>
                                                                </span>
                                                            </span>
                                                        </v-row>
                                                    </th>
                                                </div>
                                            </tr>
                                        </v-row>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <br />
            <v-expansion-panels class="expapanel no-display" focusable inset>
                <v-expansion-panel>
                    <v-expansion-panel-header class="panelheader toolbar12">Billing History </v-expansion-panel-header>
                    <v-expansion-panel-content class="mt-5">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <v-icon color="error">*</v-icon>
                                From Date ::
                                <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                                <v-icon color="error" class="ml-3">*</v-icon>
                                To Date ::
                                <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
                                <v-btn class="button" @click="getBillingHistory()">Proceed</v-btn>
                            </v-col>
                            <v-data-table v-if="billing_history != ''" dense class="elevation-1 mytable"
                                :headers="headers1" :items="billing_history" fixed-header>
                                <template v-slot:item.details="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on">
                                                <v-icon color="black"
                                                    @click="getBillHistory(item)">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span> View Details</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
        <v-dialog v-model="dialog_bill_details" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Bill Details
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_bill_details=false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <v-col v-if="billing_history_details!=null" cols="12" sm="12" md="`12">
                    <!-- { "date": "06/Mar/2023", "debit_history": [], "balance": 100, "th_id": 3, "credit_history": [ { "date": "06/Mar/2023", "amount": 100, 
                    "paymentmode": "Online", "transaction_type": "Online" } ], 
                    "count": 1, "credit_amount": 100, "transactiontype": "Credit" } -->
                    <span v-if="billing_history_details.transactiontype == 'Credit'">
                        <v-data-table v-if="billing_history_details.credit_history != ''" dense
                            class="elevation-1 mytable" :headers="headers2"
                            :items="billing_history_details.credit_history" fixed-header>
                        </v-data-table>
                    </span>
                    <span v-if="billing_history_details.transactiontype == 'Debit'">
                        <v-data-table v-if="billing_history_details.debit_history != ''" dense
                            class="elevation-1 mytable" :headers="headers3"
                            :items="billing_history_details.debit_history" fixed-header>
                        </v-data-table>
                    </span>
                    <!-- {{billing_history_details.transactiontype}} -->
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_issue" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Raise Dispute
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_issue=false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <v-col cols="12" sm="12" md="`12">
                    <center>
                        You can raise dispute, if amount is deducted from your bank, but receipt is not generated.
                        <br />
                        Click on "Proceed", which will redirect to Payment History Page where you can raise dispute for
                        that transaction. <br />
                        Refer below figure for the same.
                        <img :src="history" width="100%" height="100%" alt="logo" />
                    </center>
                </v-col>
                <v-row justify="center">
                    <v-btn class="button">
                        <router-link style="text-decoration: none; color: black;" :to="{name: 'parent-fee-history' }"
                            class="root">
                            Proceed
                        </router-link>
                    </v-btn>
                    <v-btn class="button no-display" @click="dialog_issue=false">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import axios from "axios";
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            get_component_installmet_list: [],
            show: false,
            dialog_outsatnding: false,
            dialog_issue: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
            leaner_std: null,
            leaner_div: null,
            installment_list: [],
            inst_id: null,
            matrix_list: "",
            total_amount: "",
            paid_amount: "",
            fees_amount: "",
            debit_card_charges: "",
            credit_card_charges: "",
            netbanking_card_charges: "",
            fine: "",
            display_flag: false,
            matrix_pg_list: null,
            pg_hidden: null,
            pg_loader: false,
            path: null,
            history: null,
            amount: null,
            basic_student_data: null,
            payment_data: null,
            current_wallet_balance:null,
            richarge_history: [],
            //fromdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            billing_history:[],
            billing_history_details:null,
            dialog_bill_details:false,
             filterArr: [],
                filters: {
                   transaction_type:[],
                   date:[],
                },

             headers3: [
                { text: "Item", value: "item" },
                { text: "Transaction Date", value: "order_date" },
                { text: "Order Id", value: "orderid" },
                { text: "Rate", value: "rate" },
                { text: "Quantity", value: "quantity" },
                { text: "Total Amount In Rs.", value: "amount" },
            ],

            headers2: [
                { text: "Amount In Rs.", value: "amount" },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Type", value: "transaction_type" },
                { text: "Payment Mode", value: "paymentmode" },
            ],
            headers: [
                { text: "Sr No", value: "count" },
                { text: "Amount In Rs.", value: "amount" },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Type", value: "transaction_type" },
            ],
            headers1: [
                { text: "Sr No", value: "count" },
                { text: "Transaction Date", value: "date" },
                { text: "Debit Amount", value: "debit_amount" },
                { text: "Credit Amount", value: "credit_amount" },
                { text: "Balance Amount", value: "balance" },
                { text: "Details", value: "details" },
                
            ],
        }),
        created() {
            // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytmCanteenWallet";
        },
        computed: {
            bookList1() {
                return this.richarge_history.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
              getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.richarge_history.map((d) => d[val]);
            },
            getBillHistory(item){
                this.billing_history_details = item
                this.dialog_bill_details = true
            },
            payment() {
                var formData = new FormData(paytmform);
                this.pg_loader = false;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getBillingHistory(){
                this.billing_history = []
                 const formData = {
                    learner_id: this.selected_children,
                    fromdate:this.fromdate,
                    todate:this.todate
                };
                axios
                    .post("/Wallet/getBillingHistory", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.billing_history = res.data.billing_history
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
            getData() {
                this.basic_student_data = null;
                this.payment_data = null;
                this.richarge_history = [];
                this.current_wallet_balance = null
                const formData = {
                    learner_id: this.selected_children,
                };
                axios
                    .post("/Wallet/onlineWalletPaymentHome", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.basic_student_data = res.data.basic_student_data;
                            this.payment_data = res.data.payment_data;
                            this.current_wallet_balance = res.data.current_wallet_balance;
                            this.richarge_history = res.data.richarge_history;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            let org_id = localStorage.getItem("EPS-tenant");
            this.history = "https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/payment_history.jpeg";
            if (org_id == "zeal") {
                this.path = null;
            } else if (org_id == "sbpps") {
                this.path = "https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Documents/S.B.P.P.S+Cancellation+Policy+++2021-22.pdf";
            } else if (org_id == "wws") {
                this.path = "https://wws-schoolerp.s3.ap-south-1.amazonaws.com/documents/wws_payment_policies.pdf";
            }
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>
<style scoped>
input[type="date"] {
  width: 30%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.toolbar12 {
  background:#E57C23;/* #8360c3; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #E57C23
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #E57C23
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
}
 .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
